<template>
  <v-card flat color="#f1f1f1" class="pa-2">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title> <b>Resumo</b> </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-simple-table style="background-color: transparent">
      <thead>
        <tr>
          <th>Equipamento</th>
          <th width="130" class="text-right">Valor reclamado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="equipament in equipaments" :key="equipament.id">
          <td>
            {{
              `${equipament.product.product_type} ${equipament.product.brand} ${equipament.product.model}`
            }}
          </td>
          <td class="text-right">
            {{
              equipament.invoice
                ? money.euro(equipament.invoice.total_amount)
                : "---"
            }}
          </td>
        </tr>
        <tr v-if="equipaments.length < 1">
          <td colspan="2" class="text-center caption">
            Adicione equipamentos para ver o resumo
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="text-right font-weight-bold">Total reclamado</td>
          <td class="text-right font-weight-bold">
            {{ money.euro(totalClaimed) }}
          </td>
        </tr>
      </tfoot>
    </v-simple-table>
  </v-card>
</template>

<script>
import money from "@/tools/money";

export default {
  mixins: [],

  components: {},

  props: {
    equipaments: Array,
  },

  data() {
    return {
      money,
    };
  },

  methods: {},

  computed: {
    totalClaimed() {
      let total = 0;

      this.equipaments.forEach((equipament) => {
        if (!equipament.invoice) {
          return;
        }

        total += Number.parseFloat(equipament.invoice.total_amount);
      });

      return total;
    },
  },
};
</script>
